<template>
	<div>
		<!-- 面包屑导航区 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>题目管理</el-breadcrumb-item>
			<el-breadcrumb-item>知识点列表</el-breadcrumb-item>
		</el-breadcrumb>

		<!-- 卡片视图 -->
		<el-card class="box-card">
			<!-- 搜索与添加 -->
			<el-row :gutter="20">
				<el-col :span="8">
					<!-- <el-input clearable @clear="getUserList" placeholder="请输入内容（问题内容）" v-model="queryInfo.query">
                        <el-button @click="getUserList" slot="append" icon="el-icon-search"></el-button>
                    </el-input> -->
				</el-col>
				<el-col :span="4">
					<el-button type="primary" @click="addDialogVisible = true">添加知识点</el-button>
				</el-col>
			</el-row>

			<!-- 知识点列表 -->
			<el-table border stripe :data="userlist" style="width: 100%">
				<el-table-column type="index" label="#"></el-table-column>
				<el-table-column prop="username" label="一体机"></el-table-column>
				<el-table-column prop="image" label="背景图一">
					<template slot-scope="scope">
						<img class="imgss" :src="scope.row.image1" alt="">
					</template>
				</el-table-column>
				<el-table-column prop="image" label="背景图二">
					<template slot-scope="scope">
						<img class="imgss" :src="scope.row.image2" alt="">
					</template>
				</el-table-column>
				<el-table-column prop="image" label="背景图三">
					<template slot-scope="scope">
						<img class="imgss" :src="scope.row.image3" alt="">
					</template>
				</el-table-column>
				<el-table-column prop="content1" label="知识一"></el-table-column>
				<el-table-column prop="content2" label="知识二"></el-table-column>
				<el-table-column prop="content3" label="知识三"></el-table-column>
				<el-table-column label="操作" width="180px">
					<template slot-scope="scope">
						<!-- 修改按钮 -->
						<!-- <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)"></el-button> -->
						<!-- 删除 -->
						<el-button type="danger" icon="el-icon-delete" size="mini"
							@click="removeUserById(scope.row.id)"></el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页 -->
			<div class="block">
				<!-- <span class="demonstration">完整功能</span> -->
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="queryInfo.pagenum" :page-sizes="[2, 5, 10, 15]" :page-size="queryInfo.pagesize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</el-card>

		<!-- 添加知识点对话框 -->
		<el-dialog title="添加知识点" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
			<!-- 内容主体区域 -->
			<el-form :model="addForm" ref="addFormRef" label-width="70px">
				<el-form-item label="一体机">
					<el-cascader v-model="addForm.username" :options="options" props.multiple=false clearable>
					</el-cascader>
				</el-form-item>
				<el-form-item label="知识一">
					<el-input v-model="addForm.content1"></el-input>
				</el-form-item>
				<el-form-item label="知识二">
					<el-input v-model="addForm.content2"></el-input>
				</el-form-item>
				<el-form-item label="知识三">
					<el-input v-model="addForm.content3"></el-input>
				</el-form-item>
				<el-form-item label="背景图">
					<el-input v-model="addForm.image" v-if="false"></el-input>
					<el-upload class="upload-demo" action="https://api-bld.safe-union.com/wxApp/uploadfile"
						:on-preview="handlePreview" :on-remove="handleRemove" :on-success="handSuccess"
						:before-remove="beforeRemove" list-type="picture" multiple :limit="3" :on-exceed="handleExceed"
						:file-list="fileList">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
					</el-upload>

				</el-form-item>
			</el-form>
			<!-- 底部区域 -->
			<div slot="footer" class="dialog-footer">
				<el-button @click="addDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="addUser">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	export default {
		props: {
			classfy: String
		},
		data() {
			return {
				fileList: [{
					name: ''
				}],
				//   控制知识点对话框的显示隐藏
				editDialogVisible: false,
				//   控制知识点对话框的显示隐藏
				addDialogVisible: false,
				// 获取知识点列表的参数对象
				queryInfo: {
					query: 'hxsys',
					// 当前的页数
					pagenum: 1,
					// 当前每页显示多少数据
					pagesize: 5
				},
				// 添加知识点的表单数据
				addForm: {
					content1: '',
					content2: '',
					content3: '',
					image1: '',
					image2: '',
					image3: '',
					username: ''
				},
				userlist: [],
				cateProps: {
					multiple: true,
					emitPath: false
				},
				total: 0,
				options: [{
					value: 'hxsys',
					label: '化学实验室'
				}],
			}
		},
		created() {
		},
		watch:{
			classfy(){
				this.queryInfo.pagenum = 1;
				this.queryInfo.pagesize = 5;
				this.queryInfo.query = this.classfy;
				
				this.getUserList();
				this.initOptions();
			}
		},
		methods: {
			async getUserList() {
				const {
					data: res
				} = await this.$http.post('/curriculim', {
					params: this.queryInfo
				})
				console.log(res)
				for (const key in res.users) {
					res.users[key].username = this.options[0]['label'];
				}
				this.userlist = res.users
				this.total = res.totalpage
			},
			//初始化一体机选项
			initOptions(){
				let options = {};
				switch(this.classfy){
					case 'xsss':
						options = {value: 'xsss', label: '学生宿舍'};
					break;
					case 'xyjws':
						options = {value: 'xyjws', label: '校园警务室'};
					break;
					case 'jxl':
						options = {value: 'jxl', label: '教学楼安全'};
					break;
					case 'yjjy':
						options = {value: 'yjjy', label: '应急救援'};
					break;
					case 'wb':
						options = {value: 'wb', label: '网吧'};
					break;
					case 'xc':
						options = {value: 'xc', label: '校车安全'};
					break;
					case 'sd':
						options = {value: 'sd', label: '书店'};
					break;
					case 'wc':
						options = {value: 'wc', label: '重点车辆安全'};
					break;
					case 'kyz':
						options = {value: 'kyz', label: '客运车安全'};
					break;
					case 'kycaq':
						options = {value: 'kycaq', label: '客运车安全'};
					break;
					case 'spxzf':
						options = {value: 'spxzf', label: '食品加工小作坊'};
					break;
					case 'spjgxzf':
						options = {value: 'spjgxzf', label: '食品加工小作坊'};
					break;
					case 'bld':
						options = {value: 'bld', label: '便民超市'};
					break;
					case 'bmcs':
						options = {value: 'bmcs', label: '便民超市'};
					break;
					case 'cydcf':
						options = {value: 'cydcf', label: '餐饮店厨房'};
					break;
					case 'tzc':
						options = {value: 'tzc', label: '童装厂'};
					break;
					case 'czw':
						options = {value: 'czw', label: '居住出租屋'};
					break;
					case 'yjaq':
						options = {value: 'yjaq', label: '寄递安全'};
					break;
					case 'czw':
						options = {value: 'czw', label: '居住出租屋'};
					break;
					case 'tzsb':
						options = {value: 'tzsb', label: '特种设备'};
					break;
					case 'dxylss':
						options = {value: 'dxylss', label: '特种设备'};
					break;
					case 'dg':
						options = {value: 'dg', label: '施工用电安全'};
					break;
					case 'gjaq':
						options = {value: 'gjaq', label: '国家安全'};
					break;
					case 'guojia':
						options = {value: 'guojia', label: '国家安全'};
					break;
					case 'jzsgaq':
						options = {value: 'jzsgaq', label: '建筑工地安全'};
					break;
					case 'stzl':
						options = {value: 'stzl', label: '生态治理'};
					break;
					case 'hdzl':
						options = {value: 'hdzl', label: '生态治理'};
					break;
					case 'rq':
						options = {value: 'rq', label: '燃气安全'};
					break;
					case 'aqsc':
						options = {value: 'aqsc', label: '生产车间'};
					break;
					case 'sccj':
						options = {value: 'sccj', label: '生产车间'};
					break;
					case 'xj':
						options = {value: 'xj', label: '防范邪教'};
					break;
					case 'fank':
						options = {value: 'fank', label: '反恐防暴'};
					break;
					case 'weih':
						options = {value: 'weih', label: '危化企业'};
					break;
					case 'bmyd':
						options = {value: 'bmyd', label: '便民药店'};
					break;
					case 'hxsys':
						options = {value: "hxsys", label: '化学实验室'};
					break;
					default: break;
				}
				this.options = [options];
			},

			// 监听 pagesize 改变的事件
			handleSizeChange(newSize) {
				//   console.log(newSize)
				this.queryInfo.pagesize = newSize
				this.getUserList()
			},
			// 监听 页码值改变的事件
			handleCurrentChange(newpage) {
				//   console.log(newpage)
				this.queryInfo.pagenum = newpage
				this.getUserList()
			},
			// 监听添加知识点对话框的关闭事件
			addDialogClosed() {
				this.$refs.addFormRef.resetFields()
			},

			// 添加按钮，添加新知识点
			addUser() {
				this.$refs.addFormRef.validate(async valid => {
					if (!valid) return
					await this.$http.post('/knowleImguser/establish', this.addForm)
					this.$message.success('知识点添加成功！')
					this.addForm = {
						content1: '',
						content2: '',
						content3: '',
						image1: '',
						image2: '',
						image3: '',
						username: ''
					}
					// 隐藏对话框
					this.addDialogVisible = false
					// 刷新
					this.getUserList()
				})
			},

			// 监听修改知识点对话框的关闭事件
			editDialogClosed() {
				this.$refs.editFormRef.resetFields()
			},

			// 删除按钮
			async removeUserById(id) {
				const confirmResult = await this.$confirm('此操作将永久删除该知识点，是否继续？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).catch(err => err)
				if (confirmResult !== 'confirm') {
					return this.$message.info('已取消删除!')
				}
				await this.$http.delete('/knowleImguser/' + id)
				this.$message.success('知识点删除成功!')
				// 刷新
				this.getUserList()
			},
			handleRemove(file, fileList) {
				console.log(file, fileList)
			},
			handlePreview(file) {
				console.log(file)
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${file.name}？`)
			},
			handSuccess(fileList) {
				console.log(fileList.data.url)
				if (this.addForm.image1.length !== 0) {
					this.addForm.image2 = fileList.data.url
					console.log(2)
				} else if (this.addForm.image2.length !== 0) {
					this.addForm.image3 = fileList.data.url
					console.log(3)
				} else {
					this.addForm.image1 = fileList.data.url
					console.log(1)
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.imgss {
		width: 100px;
	}
</style>
